import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-catalogs-new-product',
  templateUrl: './catalogs-new-product.component.html',
  styleUrls: ['./catalogs-new-product.component.scss']
})
export class CatalogsNewProductComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
